/* tslint:disable */
/* eslint-disable */
/**
 * wicky_ups
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../../../Components/api/runtime';
import {
    ChunkedListBase,
    ChunkedListBaseFromJSON,
    ChunkedListBaseFromJSONTyped,
    ChunkedListBaseToJSON,
    ErrorStation,
    ErrorStationFromJSON,
    ErrorStationFromJSONTyped,
    ErrorStationToJSON,
    ErrorStationListChunkAllOf,
    ErrorStationListChunkAllOfFromJSON,
    ErrorStationListChunkAllOfFromJSONTyped,
    ErrorStationListChunkAllOfToJSON,
} from './';

/**
 * 
 * @export
 * @interface ErrorStationListChunk
 */
export interface ErrorStationListChunk {
    /**
     * 
     * @type {number}
     * @memberof ErrorStationListChunk
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ErrorStationListChunk
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof ErrorStationListChunk
     */
    totalCount: number;
    /**
     * 
     * @type {number}
     * @memberof ErrorStationListChunk
     */
    pageCount: number;
    /**
     * 
     * @type {Array<ErrorStation>}
     * @memberof ErrorStationListChunk
     */
    chunk: Array<ErrorStation>;
}

export function ErrorStationListChunkFromJSON(json: any): ErrorStationListChunk {
    return ErrorStationListChunkFromJSONTyped(json, false);
}

export function ErrorStationListChunkFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorStationListChunk {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'page': json['page'],
        'size': json['size'],
        'totalCount': json['totalCount'],
        'pageCount': json['pageCount'],
        'chunk': ((json['chunk'] as Array<any>).map(ErrorStationFromJSON)),
    };
}

export function ErrorStationListChunkToJSON(value?: ErrorStationListChunk | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'page': value.page,
        'size': value.size,
        'totalCount': value.totalCount,
        'pageCount': value.pageCount,
        'chunk': ((value.chunk as Array<any>).map(ErrorStationToJSON)),
    };
}


